import Vue from 'vue'
import VueRouter from 'vue-router'
import Multiguard from 'vue-router-multiguard';

import Main from '../views/Home.vue'

import AuthView from '../views/AuthView.vue'
import AccountStatus from '../views/AccountStatus.vue'
import AccountForm from '../views/AccountForm.vue'

import Profile from '../views/Profile.vue'

import Login from '../components/auth/login'
import ForcePassChange from '../views/UserPasswordChange'
import Recover from '../components/auth/recover'


import store from '@/store'

Vue.use(VueRouter)

const checkAuthenticated = (to, from, next) => {
    if( !store.getters['auth/authenticated'] ){
        return next({
            name: 'auth.login'
        })
    }
    next()
}

const checkPasswordChanged = (to, from, next) => {
    if( !store.getters['auth/passwordChanged'] ){
        return next({
            name: 'auth.changepassword'
        })
    }
    next()
}

const routes = [
    {
        path: '/auth',
        component: AuthView,
        children: [
            { path: '', name: 'auth', component: Login },
            { path: 'login', name: 'auth.login', component: Login },
            { path: 'recover', name: 'auth.recover', component: Recover },
        ]
    },
    {
        path: '/change-password',
        name: 'auth.changepassword',
        component: ForcePassChange,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/',
        component: Main,
        beforeEnter: Multiguard([checkAuthenticated, checkPasswordChanged]),
        children: [
            { path: '', name: 'home', component: Profile },
            { path: 'profile', name: 'profile', component: Profile },
            { path: 'account-status', name: 'account.status', component: AccountStatus },
            { path: 'account-form', name: 'account.form', component: AccountForm },
        ]
    },

    { path: '*', redirect: '/', beforeEnter: checkAuthenticated }
]

const router = new VueRouter({
	mode: 'history',
    base: '/proveedores',
    linkActiveClass: "is-active",
	routes
})

export default router
